import React from 'react';
import {connect} from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import * as ResourceApi from "api/resources";
import {getAllResourcesAction} from "resources/actions";
import {filterOptionsFactory, sortOptionsFactory} from "viewOptions/factories";
import BreakCategoryEditor from 'components/forms/CustomFields/BreakCategoriesEditor';
import {createResourceTypeSelector} from "resources/selectors";
import AutoSaveDropdown from 'components/forms/AutoSaveFormFields/AutoSaveDropdown';
import BreakSiteCategoryDropdown from 'components/forms/CustomFields/BreakSite/BreakSiteCategoryDropdown'
import {injectIntl} from 'react-intl';

const getCategoryItems = createResourceTypeSelector(ResourceApi.Types.Category);

const mapStateToProps = (state, ownProps) => {
    console.log(`BreakCategoryEditorComposed mapStateToProps`, state)
    // console.log(`ownProps`, ownProps)

    // console.log(`ownProps currentResource`, ownProps.formProxy.currentResource)
    // console.log(`ownProps currentValue`, ownProps.formProxy.currentValue)
    
    let categories = (getCategoryItems(state.resources) || [])  // ALL categories

    let options = categories            // options is a subset of categories 
    .filter((category) => {
        return (category.siteId === ownProps.formProxy.currentResource.siteId)
    })
    .reduce((previous, category, index) => {
        // console.log(`reduce category`, category)

        // return {
        //     value: category.category,
        //     text: category.category 
        // };  

        let subcategories =  category.subcategories.map((subcategory, index) => {
            // console.log(`subcategory`, subcategory)
            // this.props.intl.formatMessage({id: `editbreak.breaksNavFilters.${option.text}`})
            return {
                value: subcategory,
                // text: category.category + ' - ' + subcategory
                // text: subcategory
                text: ownProps.intl.formatMessage({id: `editbreak.breaksNavFilters.${category.category}`}) + ownProps.intl.formatMessage({id: `editbreak.breaksNavFilters.${subcategory}`})
            };                        

        })

        return previous.concat(subcategories)
    }, [])

    const onValueChanged = (value, field, noIdea) => {
        console.log(`onValueChanged`, value)
        ownProps.onValueChanged(value, field, noIdea)
    }

    return ({
        options: options,
        categories: categories,
        onValueChanged: onValueChanged
    });
    
}
const mapDispatchToProps = (dispatch, ownProps) => {
    // console.log(`BreakCategoryEditorConnected mapDispatchToProps`, ownProps)
    return {
    };
    
}
const BreakCategoryEditorConnected = connect(mapStateToProps, mapDispatchToProps);

const BreakCategoryLifecycle = lifecycle({
    componentDidMount: function() {
        console.log(`componentDidMount`, this.props)
    }
});

const BreakCategoryEditorComposed = compose(
    BreakCategoryEditorConnected,
    BreakCategoryLifecycle
)(BreakSiteCategoryDropdown)
// )(BreakCategoryEditor);     // component re-shapes the output format into an array of strings 
// )(AutoSaveDropdown)

export default injectIntl(BreakCategoryEditorComposed)



// WEBPACK FOOTER //
// ./public/components/composites/BreakSiteCategoryConnected.jsx